/** Normalise UK postcode for lookup (e.g. "se217ar" → "SE21 7AR"). */
export function normalizeUkPostcode(input: string): string {
  const compact = input.trim().toUpperCase().replace(/\s+/g, '');
  if (!compact) return '';
  const match = compact.match(/^([A-Z]{1,2}\d[A-Z\d]?)(\d[A-Z]{2})$/);
  if (match) return `${match[1]} ${match[2]}`;
  return input.trim().toUpperCase();
}

export interface UkPostcodeResult {
  lat: number;
  lng: number;
  postcode: string;
  address: string;
}

/** Look up a UK postcode via postcodes.io (free, no API key). */
export async function geocodeUkPostcode(postcode: string): Promise<UkPostcodeResult | null> {
  const normalised = normalizeUkPostcode(postcode);
  if (!normalised) return null;

  const res = await fetch(
    `https://api.postcodes.io/postcodes/${encodeURIComponent(normalised)}`
  );
  if (!res.ok) return null;

  const data = await res.json();
  if (data.status !== 200 || !data.result) return null;

  const r = data.result;
  const locality = r.admin_ward || r.parish || r.admin_district || '';
  const region = r.admin_county || r.region || '';
  const address = [locality, region, r.postcode].filter(Boolean).join(', ');

  return {
    lat: r.latitude,
    lng: r.longitude,
    postcode: r.postcode,
    address: address || r.postcode,
  };
}
